import React from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import DealsSection from "../deals/DealsSection";
const Deals = () => {
    return(  
         <>
          <MyNavbar/>
          <DealsSection/>
          <Footer/>
        
         </>
  );
};

export default Deals;